export default __webpack_public_path__ + "static/media/actualizar.476e0813.svg";